import { authResponseProps } from './properties'

export const clearAuthData = state => {
    state.authResponse = JSON.parse(JSON.stringify(authResponseProps))
}

export const setAlert = (state, payload) => {
    
    document.getElementById('snackbarid').click()
    
    state.alert.show = true
    state.alert.message = payload.message
}

export const showAuthModal = (state, payload) => {
    state.authModal.show = true
    state.authModal.admin = payload.admin
    state.authModal.title = payload.admin == 0 ? 'message.authenticateAsAdmin' : 'message.authenticate'
    state.authModal.target =  payload.target
    state.authModal.targetParameters = payload.targetParameters
}

export const setAuthDialogOff = state => {
    state.authModal.show = false
    state.authModal.admin = 0
    state.authModal.title = ''
    state.authModal.target =  ''
    state.authModal.targetParameters = []
}

export const setUserauthResponse = (state, payload) => {

    state.authResponse = payload
    
    if(payload.modules == 'ALL') {
        state.authResponse.modules = {menus: 'ALL'}
        state.authResponse.admin = true
    } else {
        state.authResponse.modules = payload.modules
        state.authResponse.admin = false
    }

}

export const setAlertBox = (state, payload) => {
    state.alertBox.show = true
    state.alertBox.title = payload.title
    state.alertBox.message = payload.message
}

export const setConfirmBox = (state, payload) => {
    state.confirmBox.show = true
    state.confirmBox.title = payload.title
    state.confirmBox.message = payload.message
    state.confirmBox.followingAction = payload.followingAction
}

export const setConfirmBoxOff = state => {
    state.confirmBox.show = false    
}

export const setReligion = (state, payload) => {
    state.general.religion = payload
}

export const setCountries = (state, payload) => {
    state.general.countries = payload
}

export const setRelations = (state, payload) => {
    state.general.relations = payload
}

export const setReminderList = (state, payload) => {
    state.reminders = payload
}

export const setDashboardValues = (state, payload) => {
    state.dashboard = payload
}

export const toggleLoginStatus = (state) => {
    state.toggleLogin = true
}

export const setDashboardProps = (state, payload) => {
    state.dashboardProps = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js